import React, { useState } from 'react';
import { companyInfo } from '../data/mock';

/**
 * Resilient brand logo.
 * - Loads `companyInfo.logo` eagerly (no lazy-load — this is above-the-fold).
 * - On any image error (CDN hiccup, network blip, expired URL), gracefully
 *   degrades to a styled wordmark instead of the browser's broken-image icon.
 *
 * Props:
 *   - className: classes applied to the <img> (sizing, e.g., "h-14 sm:h-16 w-auto")
 *   - fallbackClassName: classes applied to the text fallback (defaults to a
 *     light-on-dark navbar style; pass your own to override e.g. dark-on-light)
 */
const BrandLogo = ({
  className = 'h-14 sm:h-16 w-auto',
  fallbackClassName = 'text-base sm:text-lg font-bold tracking-wide text-white whitespace-nowrap',
  testId = 'brand-logo-img',
}) => {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return (
      <span className={fallbackClassName} data-testid="brand-logo-fallback">
        {companyInfo.name}
      </span>
    );
  }

  return (
    <img
      src={companyInfo.logo}
      alt={companyInfo.name}
      className={className}
      decoding="async"
      onError={() => setErrored(true)}
      data-testid={testId}
    />
  );
};

export default BrandLogo;
